import { axiosInstanceWithToken } from 'utils/axios';
import {
  ISignInRequest,
  ISignUpRequest,
  IEmailValidateRequest,
  IResetTokenValidateRequest,
  ISignInResponse,
  IRefreshTokenResponse,
  IForgotPasswordRequest,
  IRecoverPassword,
  IUserResourceWithRelations,
} from '../../server/types';

export const signIn = async (data: ISignInRequest) =>
  axiosInstanceWithToken().post<ISignInResponse>('auth/sign-in', data);

export const signUp = async (data: ISignUpRequest) =>
  axiosInstanceWithToken().post<IUserResourceWithRelations>('auth/sign-up', data);

export const validateEmail = async (data: IEmailValidateRequest) =>
  axiosInstanceWithToken().post<string>('auth/validate-email', data);

export const validateReset = async (data: IResetTokenValidateRequest) =>
  axiosInstanceWithToken().post<IUserResourceWithRelations>('auth/validate-reset', data);

export const fetchCurrentUser = async (token: string) =>
  axiosInstanceWithToken({
    Authorization: `Bearer ${token}`,
  }).get<IUserResourceWithRelations>('auth/current-user');

export const refreshToken = async () => axiosInstanceWithToken().get<IRefreshTokenResponse>('auth/refresh-token');

export const sendForgotPassword = async (data: IForgotPasswordRequest) =>
  axiosInstanceWithToken().post<string>('auth/forgot-password', data);

export const recoverPassword = async (data: IRecoverPassword) =>
  axiosInstanceWithToken().post<void>('auth/recover-password', data);
